import { FlowState, Location } from '../types/flow.types';

export const getLocationIndexDisplay = (orderIndex: number, flowLocations: Location[]): string => {
  if (orderIndex === -1) {
    return '[-1] Not used';
  }
  
  const sortedLocations = [...flowLocations].sort((a, b) => a.orderIndex - b.orderIndex);
  const arrayIndex = sortedLocations.findIndex(loc => loc.orderIndex === orderIndex);
  const location = sortedLocations[arrayIndex];
  
  return location ? `[${arrayIndex}] ${location.name}` : `[?] Unknown`;
};

export const getStateLabel = (state: number, flowStates: FlowState[]): string => {
  switch (state) {
    case -1:
      return 'Completed';
    default:
      const flowState = flowStates.find(s => s.state === state);
      return flowState ? `${flowState.status} (${state})` : `${state}`;
  }
};

export const getValidStates = (flowStates: FlowState[]): number[] => {
  return [-1, ...flowStates.map(state => state.state)];
};

export const canMoveUp = (currentArrayIndex: number): boolean => {
  return currentArrayIndex > 0;
};

export const canMoveDown = (currentArrayIndex: number, totalLocations: number): boolean => {
  return currentArrayIndex < totalLocations - 1;
};
